import { useQueryClient } from '@tanstack/react-query';
import { useOptimisticMutation } from '../../../hooks/use-optimistic-mutation';
import { transformSettingsToApiResponse } from '../transformers';
import type { CustomerGroupBuilderValidated } from '../types/customer-group.schema';
import type { CustomerGroupApiResponse } from '../types/customer-group-response';
import { QK_GET_CUSTOMER_GROUPS } from './use-customer-groups';
import { useCustomerGroupsApi } from './use-customer-groups-api';

export function useUpdateCustomerGroup() {
  const { customerGroupsApi } = useCustomerGroupsApi();
  const queryClient = useQueryClient();

  return useOptimisticMutation<CustomerGroupApiResponse[], CustomerGroupBuilderValidated>({
    queryClient,
    queryKey: QK_GET_CUSTOMER_GROUPS(),
    mutationFn: (group) => customerGroupsApi.group(group.slug).update(group),
    optimisticUpdate: (prev, newGroup) => {
      return prev?.map((group) => {
        if (group.slug === newGroup.slug) {
          return {
            ...newGroup,
            settings: transformSettingsToApiResponse(newGroup.settings),
          };
        }
        return group;
      });
    },
  });
}
